module.exports = __webpack_public_path__ + "static/media/bookstorephp.ddf50fc0.JPG";